import { Component, OnInit } from '@angular/core';
import { Transaction } from '../../../models';
import { TokenServiceService } from '../../../services/token-service.service';
import { AuthorizationDesc } from '../../../models/order';
import { AlertService } from '../../../services/alert.service';
import { PrintServicesService } from '../../../services/print-services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ClaroPayService } from 'src/app/services/claro-pay.service';
import { GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { Subscription } from 'rxjs';
import { ResponseModel } from 'src/app/models/response';
import moment from 'moment';

const TIME_OUT_TO_RETRY = 30;
const TRY_LEFT_CONSULT = 3;

@Component({
  selector: 'app-check-order-status',
  templateUrl: './check-order-status.component.html',
  styleUrls: ['./check-order-status.component.scss']
})
export class CheckOrderStatusComponent implements OnInit {

  claroOrderSubscribe: Subscription;
  order: AuthorizationDesc;
  transaction: Transaction;
  redirect: string;
  responseOrderStatus: string;
  icon = 'spinner';
  messageResponse: string;
  claroOrderId: string;
  claroOrderToken: string;
  approve: boolean;
  processFail: boolean;
  loading = true;
  isPending = false;
  infoPayment = true;
  isExpired = false;
  timeIntervalToRequestAgain = TIME_OUT_TO_RETRY;
  tryLeftConsult = TRY_LEFT_CONSULT;
  transactionStatus = GENERAL_CONSTANTS.RESPONSE_ERROR_CLARO_PLAY.TRANSACTION_STATUS;
  errorsClaroPay = GENERAL_CONSTANTS.RESPONSE_ERROR_CLARO_PLAY;
  transationMessageStatus = GENERAL_CONSTANTS.TRANSACTION_MESSAGE_STATUS;

  /**
   * @description loadStyle
   */
  static loadStyle() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `./assets/css/root/default.css`;
    document.getElementsByTagName('HEAD')[0].appendChild(link);
  }

  constructor(
    private readonly tokenServiceService: TokenServiceService,
    private readonly alertService: AlertService,
    private readonly printServicesService: PrintServicesService,
    private readonly router: Router,
    private readonly claroPayService: ClaroPayService,
    private readonly activatedRoute: ActivatedRoute
  ) { }

  async ngOnInit() {
    CheckOrderStatusComponent.loadStyle();
    this.transaction = this.tokenServiceService.getAndDecodeToken();
    this.claroOrderSubscribe = this.activatedRoute.queryParams.subscribe(params => {
      this.claroOrderId = params.claroOrderId;
      this.claroOrderToken = params.token;
    });
    await this.consultOrderState();
  }

  /**
   * @description intervalLogic logic to add waiting times for payment order
   */
  intervalLogic() {
    this.loading = false;
    const retryRequestInterval = setInterval(async () => {
      if (this.timeIntervalToRequestAgain <= 0) {
        this.timeIntervalToRequestAgain = TIME_OUT_TO_RETRY;
        clearInterval(retryRequestInterval);
        this.tryLeftConsult--;
        await this.consultOrderState();
      } else {
        this.timeIntervalToRequestAgain = this.timeIntervalToRequestAgain - 1;
      }
    }, 1000);
  }
  /**
   * @description consultOrderState Check order status by ClaroPay identifier
   */
  async consultOrderState() {
    try {
      if (this.tryLeftConsult > 0) {
        let requestBody = { claroOrderId: this.claroOrderId };
        this.claroPayService.claroPayPaymentInfo(requestBody, this.claroOrderToken).subscribe({
          next: (res: ResponseModel) => {
            let status = res.DATA['status'];
            if (res.CODE === GENERAL_CONSTANTS.OK_RESPONSE_CODE) {
              if (status === this.transactionStatus.CHARGE_IN_PROGRESS ||
                status === this.transactionStatus.NULL ||
                status === this.transactionStatus.CREATED ||
                status === this.transactionStatus.PAID) {
                this.responseOrderStatus = this.transationMessageStatus.PENDING.TITLE;
                this.isPending = true;
                this.infoPayment = false;
                this.intervalLogic();
              } else {
                this.processResponseOrder(res);
              }
            } else {
              this.alertService.showAlert(res.TEXT, 'warning', this.errorsClaroPay.ERROR_CHECK_ORDER_STATUS);
            }
          }, error: (_) => {
            this.loading = false;
            this.alertService.showAlert(this.errorsClaroPay.ERROR_CHECK_ORDER_STATUS, 'warning');
          }
        });
      } else {
        this.loading = false;
      }
    } catch (e) {
      this.alertService.showAlert(this.errorsClaroPay.ERROR_CHECK_ORDER_STATUS, 'warning');
      this.loading = false;
    }
  }
  /**
 * 
 * @description processResponseOrder Process information and response of the ClaroPay order
 * @param data response claroPay order 
 */
  processResponseOrder(data: ResponseModel) {
    this.infoPayment = true;
    let status = data.DATA['status'];
    switch (status) {
      case this.transactionStatus.DELIVERED:
        this.aproved();
        break;
      case this.transactionStatus.REVERTED:
      case this.transactionStatus.CANCELLED:
      case this.transactionStatus.CHARGE_FAILED:
        this.failed();
        break;
      case this.transactionStatus.CREATED:
      case this.transactionStatus.CHARGE_IN_PROGRESS:
      case this.transactionStatus.PAID:
      case this.transactionStatus.NULL:
        this.pended();
        break;
      case this.transactionStatus.EXPIRED:
        this.expired();
        break;
      default:
        this.alertService.showAlertProblem();
        break;
    }
    this.loading = false;
  }
  /**
   * @description aproved response construction for approved orders
   */
  aproved() {
    this.responseOrderStatus = this.transationMessageStatus.APROVED.TITLE;
    this.icon = this.transationMessageStatus.APROVED.ICON;
    this.messageResponse = this.transationMessageStatus.APROVED.MESSAGE_RESPONSE;
    this.isPending = false;
    this.approve = true;
  }
  /**
   * @description pended response construction for pending orders
   */
  pended() {
    this.responseOrderStatus = this.transationMessageStatus.PENDING.TITLE;
    this.icon = this.transationMessageStatus.PENDING.ICON;
    this.messageResponse = this.transationMessageStatus.PENDING.MESSAGE_RESPONSE;
    this.isPending = true;
    this.intervalLogic();
  }
  /**
   * @description failed build response for failed commands
   */
  failed() {
    this.responseOrderStatus = this.transationMessageStatus.FAILED.TITLE;
    this.icon = this.transationMessageStatus.FAILED.ICON;
    this.messageResponse = this.transationMessageStatus.FAILED.MESSAGE_RESPONSE;
    this.isPending = false;
    this.processFail = true;
  }
  /**
   * @description failed build response for expired orders
   */
  expired() {
    this.responseOrderStatus = this.transationMessageStatus.EXPIRED.TITLE;
    this.icon = this.transationMessageStatus.EXPIRED.ICON;
    this.messageResponse = this.transationMessageStatus.EXPIRED.MESSAGE_RESPONSE;
    this.isPending = false;
    this.processFail = true;
    this.isExpired = true;
  }
  /**
   * @description printVoucher print payment order voucher
   */
  printVoucher() {
    this.printServicesService.downloadImage(
      document.getElementById('ticketDiv'),
      GENERAL_CONSTANTS.PRINT_VOUCHER_TITLE + moment().format('YYYY-MM-DD')
    );
  }
  /**
   * @description retryPayment retry payment of the ClaroPay order
   */
  async retryPayment() {
    await this.router.navigate(['/'], { queryParams: { token: this.claroOrderToken } });
  }
  /**
   * @description Function to remove subscriptions to Observables
   */
  ngOnDestroy() {
    this.claroOrderSubscribe.unsubscribe();
  }
}
